import React from "react";
import jQuery from "jquery";
import Skeleton from "react-loading-skeleton";

import {OverlayScrollbarsComponent} from "overlayscrollbars-react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCartShopping, faPlus, faAngleLeft, faAngleRight, faAngleUp} from "@fortawesome/free-solid-svg-icons";
import {FaShoppingCart, FaBox} from "react-icons/fa";

import CommonContentTop from "../CommonContentTop";
import ColumnRight from "../ColumnRight";

import dummyCategoryBanner from "../../assets/images/categoryBanner.jpg";
import dummyItemsBanner from "../../assets/images/itemDummy.jpg";

var categoryUpperSkeltonStyleObject = {
  height: 280,
  borderRadius: 12,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
};
var categoryLowerSkeltonStyleObject = {
  height: 55,
  borderRadius: 12,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
};
var categoryLowerParentDivStyleObject = {marginTop: -2, marginBottom: 30};
var numberOfCategorySkeletons = 5;

class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.osComponentCategoryList = React.createRef();
  }

  componentDidMount = async () => {
    var self = this;
    document.body.className += " fnbMenuPage";
    // this.props.setyourSelectionBlock(true);

    if (this.props.appState.fnbMenuData.length == 0) {
      await this.props.getAllMenusBySiteIdnew();
    }

    // this.props.handleCategoryTabsUiAnimation();

    jQuery(window).on("load scroll resize", function () {
      if (jQuery("#pcpfnbCategorywrapper").length > 0) {
        var stopVal = jQuery(this).scrollTop();
        var fnbpost = jQuery("#pcpfnbCategorywrapper").offset().top;
        var hHeight = jQuery(".pageHeader").outerHeight(true);
        hHeight = 0; //***Option to remove fixed header.
        var caltrgt = parseInt(fnbpost - hHeight);
        if (stopVal > caltrgt) {
          jQuery("#pcpfnbCategorywrapper").addClass("pcpfnbCategorysticky");
        } else {
          jQuery("#pcpfnbCategorywrapper").removeClass("pcpfnbCategorysticky");
        }
      }
      self.props.handleCategoryTabsUiAnimation();
    });
  };

  componentWillUnmount = () => {
    document.body.className = document.body.className.replace("fnbMenuPage", "");
  };

  /* Populating F&B Menu Tabs */
  populateMenuItemTabs = () => {
    ////////console.log("Routing > populateMenuItemTabs()");
    var menuTabs = "";
    if (this.props.appState.fnbMenuData.length > 0) {
      menuTabs = this.props.appState.fnbMenuData.map((menuItem, index) => {
        return (
          <li key={"menuItemTab_" + index + "_" + menuItem.tabid}>
            <a
              href="javascript:;"
              title={menuItem.Name}
              // // // // // data-target={"#category" + menuItem.Name.replace(/\/|\s|'|:|&/g, "_")}
              data-target={"#category" + menuItem.Name.replace(/[\/\s':&$]/g, "_")}
              //onClick={(event) => this.handleOnclickCategoryItem(event, this.osComponentCategoryList.current ) }
              onClick={(event) => this.props.handleOnclickCategoryItem(event)}
            >
              {menuItem.Name}
            </a>
          </li>
        );
      });
    }
    return menuTabs;
  };

  handleCustomArrowClick = (arrowFlag, osRefFlag) => {
    // //console.log("Menu > handleCustomArrowClick()");
    // //console.log("arrowFlag: " + arrowFlag);
    // // var osHostEle = document.getElementsByClassName("mcsbWrapper");
    // // var osHostWidth = osHostEle[0].offsetWidth;
    // // console.log("osHostWidth: " + osHostWidth);
    // //console.log(osViewportEle.offsetWidth);
    // if (arrowFlag == "scrollLeft") {
    //   osViewportEle.scrollBy(-200, 0);
    //   // jQuery(".pcpFnbblock .pcpfnbCategory ul").scrollRight(100);
    // } else {
    //   osViewportEle.scrollBy(200, 0);
    // }
    var osEle = document.getElementById("categoryOverlayScrollbar");
    var osViewportEle = osEle.querySelector(".os-viewport");
    var scrollValue = arrowFlag == "scrollLeft" ? "-=" + osViewportEle.offsetWidth + "" : "+=" + osViewportEle.offsetWidth + "";
    if (osRefFlag && osRefFlag.current && osRefFlag.current != null) {
      const osInstance = osRefFlag.current.osInstance();
      if (osInstance) {
        //osInstance.scrollStop().scroll( { x: Math.floor(Math.random() * osInstance.scroll().max.x + 0), y: Math.floor(Math.random() * osInstance.scroll().max.y + 0), }, 1000, "easeOutElastic" );
        osInstance.scroll({x: scrollValue, y: "0"}, 400);
      }
    }
  };

  /* Populating F&B Menu Tab Content */
  populateMenuItemTabContent = () => {
    ////////console.log("Routing > populateMenuItemTabContent()");
    var menuTabContent = "";
    if (this.props.appState.fnbMenuData.length > 0) {
      menuTabContent = this.props.appState.fnbMenuData.map((menuItem, index) => {
        return (
          <li
            // // // // // id={"category" + menuItem.Name.replace(/\/|\s|'|:|&/g, "_")}
            id={"category" + menuItem.Name.replace(/[\/\s':&$]/g, "_")}
            key={"menuItemTabContent_" + index + "_" + menuItem.tabid}
          >
            <section className="pcpfnbiBox roundBoxshadowed cardThumblarge noMenuImage">
              <aside
                className="pcpfnbibHead"
                //className="pcpfnbibHead collapsed"
                //data-bs-toggle="collapse"
                //data-bs-target="#collapse-categoryRecommended"
                onClick={(event) => this.props.handleCategoryThumbOnclick(event, menuItem)}
              >
                <figure className="objFitCover">
                  <img src={menuItem.IsImage == 1 && menuItem.image_url != "" ? menuItem.image_url : dummyCategoryBanner} className="img-fluid" title={menuItem.Name} alt={menuItem.Name} />
                </figure>
                <h2>
                  <span>{menuItem.Name}</span>
                </h2>
              </aside>
              <section 
                // id="collapse-categoryRecommended"
                className="pcpfnbibBody">
                <section className="pcpfnbItemlist">
                  {menuItem.Items.length > 0 ? (
                    <ul>
                      {menuItem.Items.map((fnbItem, index) => {
                        fnbItem.ageRestriction = menuItem.ageRestriction;
                        return (
                          <li
                            //className={`itemLiClass ${fnbItem.pickupAtCounter ? "fnbPickup" : "fnbDeliveryInSeat"} ${this.populateTodaysDealFlag(fnbItem.id) ? "todaysDealItem" : ""}`}
                            className={`itemLiClass`}
                            key={menuItem.id + " _ " + fnbItem.fnbItem + "_" + index}
                            // onClick={() =>
                            //   (fnbItem.active && fnbItem.show) || this.populateTodaysDealFlag(fnbItem.id)
                            //     ? this.setFnbItemModifierData(fnbItem, menuItem.id, menuItem.Name, false, menuItem.ageRestriction)
                            //     : ""
                            // }
                            // onClick={() => this.props.getModifiers()}
                            onClick={() => this.props.setFnbItemModifierData(menuItem, fnbItem)}
                            id={"fnbItem_" + fnbItem.MenuItemId + ""}
                          >
                            <figure className="itemLiFigure">
                              <img src={fnbItem.IsImage == 1 && fnbItem.image_url != "" ? fnbItem.image_url : dummyItemsBanner} className="img-fluid" title={fnbItem.Name} alt={fnbItem.Name} />
                              {/* {this.processItemImageUrl(fnbItem)} */}
                              {/* {this.populateTodaysDealFlag(fnbItem.id) ? <span className="badge bg-primary todaysDealItemBadge">Today's Deal</span> : ""} */}
                            </figure>
                            <section className="itemDetailsSection">
                              <aside className="itemDetailsAside">
                                <h3
                                  // className={`itemName ${this.populateTodaysDealFlag(fnbItem.id) ? "todaysDealItem" : ""}`}
                                  className={`itemName `}
                                >
                                  {fnbItem.Name}
                                </h3>
                                <p className="itemDetails">
                                  {fnbItem.calories != "" ? <strong>{fnbItem.calories} | </strong> : ""} {fnbItem.Description}
                                </p>
                              </aside>
                              <aside className="btnPriceAside">
                                <p className="itemPrice">{fnbItem.DisplayPrice}</p>
                                <div className="d-flex flex-column">
                                  <div className="d-flex align-items-end position-relative">
                                  {fnbItem.Alcoholdetails && fnbItem.Alcoholdetails.length > 0 ? 
                                      fnbItem.Alcoholdetails[0].Alcohol_view == "1" ? 
                                      <button 
                                        className="orderAtBarCounter"
                                        id={`button-${menuItem.MenuId + "_" + fnbItem.MenuItemId}`}
                                        >{fnbItem.Alcoholdetails[0].View_button_text != '' ? fnbItem.Alcoholdetails[0].View_button_text:''}</button>
                                       : 
                                      <button
                                      className="btn addButton1 "
                                      title="Add"
                                      // id={`button-${fnbItem.MenuItemId}`}
                                      id={`button-${menuItem.MenuId + "_" + fnbItem.MenuItemId}`}
                                      >
                                        <span className="add-to-cart">
                                          Add <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>
                                        </span>
                                        <FaShoppingCart size={20} className="fas fa-shopping-cart" />
                                        <FaBox size={13} className="fas fa-box" />
                                      </button> : 
                                      <button
                                        className="btn addButton1 "
                                        title="Add"
                                        // id={`button-${fnbItem.MenuItemId}`}
                                        id={`button-${menuItem.MenuId + "_" + fnbItem.MenuItemId}`}
                                      >
                                        <span className="add-to-cart">
                                          Add <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>
                                        </span>
                                        <FaShoppingCart size={20} className="fas fa-shopping-cart" />
                                        <FaBox size={13} className="fas fa-box" />
                                      </button> 
                                    }
                                    {/* <button
                                      className="btn addButton1 "
                                      title="Add"
                                      // id={`button-${fnbItem.MenuItemId}`}
                                      id={`button-${menuItem.MenuId + "_" + fnbItem.MenuItemId}`}
                                    >
                                      <span className="add-to-cart">
                                        Add <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>
                                      </span>
                                      <FaShoppingCart size={20} className="fas fa-shopping-cart" />
                                      <FaBox size={13} className="fas fa-box" />
                                    </button> */}
                                    {/* <a href="javascript:;" className="btn btnunavail" title="Unavailable">
                                    Unavailable
                                  </a> */}
                                  </div>
                                </div>
                              </aside>
                            </section>
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    ""
                  )}
                </section>
              </section>
            </section>
          </li>
        );
      });
    }
    return menuTabContent;
  };

  populateCategorySkeletons = () => {
    ////////console.log("Home > populateCategorySkeletons()");
    var categoryDiv = [];
    for (var i = 0; i < numberOfCategorySkeletons; i++) {
      categoryDiv.push(
        <>
          <div>
            <Skeleton duration={0.75} style={categoryUpperSkeltonStyleObject} />
          </div>
          <div style={categoryLowerParentDivStyleObject}>
            <Skeleton duration={0.75} style={categoryLowerSkeltonStyleObject} />
          </div>
        </>
      );
    }
    return categoryDiv;
  };
  
  // processItemImageUrl = (fnbItem) => {
  //   var imgValidFlag = false;
  //   if (fnbItem.IsImage == 1 && fnbItem.image_url != "") {
  //     const img = new Image();
  //     img.src = fnbItem.image_url;
  //     if (img.complete) {
  //       // callback(true);
  //       imgValidFlag = true;
  //     } else {
  //       img.onload = () => {
  //         // callback(true);
  //         imgValidFlag = true;
  //       };
        
  //       img.onerror = () => {
  //         // callback(false);
  //         imgValidFlag = false;
  //       };
  //     }
  //   }
  //   console.log("fnbItem.Name >>>>> ", fnbItem.Name);
  //   console.log("fnbItem.IsImage >>>>> ", fnbItem.IsImage);
  //   console.log("fnbItem.image_url >>>>> ", fnbItem.image_url);
  //   console.log("imgValidFlag "+ imgValidFlag);
  //   return <img src={imgValidFlag ? fnbItem.image_url : fnbItem.default_image_url} className="img-fluid" title={fnbItem.Name} alt={fnbItem.Name} />;
  // }

  render() {
    return (
      <section className="col-lg-12 col-md-12">
        <CommonContentTop appState={this.props.appState} redirectToSelectionPage={this.props.redirectToSelectionPage} />

        <section className="pcpbInner pcpFnbCategoryStrap d-none">
          <section className="pcpbiColswrap clearfix pcpFnbblock">
            <section className="pcpbiCols pcpbiColfull withOverlayScrollbar">
              <section id="pcpfnbCategorywrapper">
                <aside className="pcpfnbCategory">
                  {this.props.appState.fnbMenuData.length > 0 ? (
                    <aside className="pcpfnbcInner">
                      {/* <a href="javascript:;" className="osCustomArrows osCustomArrowLeft" onClick={() => this.handleCustomArrowClick("scrollLeft")}> Scroll Left </a> */}
                      {this.props.appState.fnbMenuData.length > 0 ? (
                        <a href="javascript:;" className="osCustomArrows osCustomArrowLeft" onClick={() => this.handleCustomArrowClick("scrollLeft", this.osComponentCategoryList)}>
                          {/* <FontAwesomeIcon icon={faAngleLeft} onClick={() => this.handleCustomArrowClick("scrollLeft")} className="scrollCaret" style={{paddingRight: 5}} /> */}
                          <FontAwesomeIcon icon={faAngleLeft} className="scrollCaret" />
                        </a>
                      ) : (
                        ""
                      )}
                      <OverlayScrollbarsComponent
                        ref={this.osComponentCategoryList}
                        options={{
                          paddingAbsolute: true,
                          autoUpdate: true,
                          scrollbars: {
                            clickScrolling: true,
                          },
                          callbacks: {
                            onInitialized: function () {
                              //console.log("OverlayScrollbarsComponent > onInitialized:");
                              var osComEle = document.getElementById("categoryOverlayScrollbar");
                              if (osComEle !== null) {
                                if (osComEle.classList.contains("os-host-scrollbar-horizontal-hidden")) {
                                  var arrowsEle = document.getElementsByClassName("osCustomArrows");
                                  for (var i = 0; i < arrowsEle.length; i++) {
                                    arrowsEle[i].classList.add("d-none");
                                  }
                                } else {
                                  var arrowsEle = document.getElementsByClassName("osCustomArrows");
                                  for (var i = 0; i < arrowsEle.length; i++) {
                                    arrowsEle[i].classList.remove("d-none");
                                  }
                                }
                              }
                            },
                            onUpdated: function () {
                              //console.log("OverlayScrollbarsComponent > onUpdated:");
                              var osComEle = document.getElementById("categoryOverlayScrollbar");
                              if (osComEle !== null) {
                                if (osComEle.classList.contains("os-host-scrollbar-horizontal-hidden")) {
                                  var arrowsEle = document.getElementsByClassName("osCustomArrows");
                                  for (var i = 0; i < arrowsEle.length; i++) {
                                    arrowsEle[i].classList.add("d-none");
                                  }
                                } else {
                                  var arrowsEle = document.getElementsByClassName("osCustomArrows");
                                  for (var i = 0; i < arrowsEle.length; i++) {
                                    arrowsEle[i].classList.remove("d-none");
                                  }
                                }
                              }
                            },
                            onOverflowChanged: function (eventArgs) {
                              //console.log("OverlayScrollbarsComponent > onOverflowChanged > eventArgs:");
                              //console.log(eventArgs);
                              if (eventArgs.xScrollable === true) {
                                var arrowsEle = document.getElementsByClassName("osCustomArrows");
                                for (var i = 0; i < arrowsEle.length; i++) {
                                  arrowsEle[i].classList.remove("d-none");
                                }
                              } else {
                                var arrowsEle = document.getElementsByClassName("osCustomArrows");
                                for (var i = 0; i < arrowsEle.length; i++) {
                                  arrowsEle[i].classList.add("d-none");
                                }
                              }
                            },
                          },
                        }}
                        className="mcsbWrapper"
                        id="categoryOverlayScrollbar"
                      >
                        <ul>{this.populateMenuItemTabs()}</ul>
                      </OverlayScrollbarsComponent>
                      {this.props.appState.fnbMenuData.length > 0 ? (
                        <a href="javascript:;" className="osCustomArrows osCustomArrowRight" onClick={() => this.handleCustomArrowClick("scrollRight", this.osComponentCategoryList)}>
                          {/* <FontAwesomeIcon icon={faAngleRight} onClick={() => this.handleCustomArrowClick("scrollRight")} className="scrollCaret" style={{paddingLeft: 8}} /> */}
                          <FontAwesomeIcon icon={faAngleRight} className="scrollCaret" />
                        </a>
                      ) : (
                        ""
                      )}
                      {/* <a href="javascript:;" className="osCustomArrows osCustomArrowRight" onClick={() => this.handleCustomArrowClick("scrollRight")}> Scroll Right </a> */}
                    </aside>
                  ) : (
                    <Skeleton duration={1} style={{height: 40, borderRadius: 12}} />
                  )}
                </aside>
              </section>
            </section>
          </section>
        </section>

        {/* E.O.Category List */}

        <section id="fnbMenuContainer">
          <section className="pcpbInner">
            <section className="pcpbiColswrap clearfix pcpFnbblock">
              <section className="pcpbiCols pcpbiColleft">
                <section className="pcpbiclInner">
                  <section className="pcpfnbCategorylist">
                    {this.props.appState.fnbMenuData.length > 0 ? <ul id="categoryList">{this.populateMenuItemTabContent()}</ul> : this.populateCategorySkeletons()}
                  </section>
                </section>
              </section>
              {/* E.O.Category Accordion List */}
              <aside className="pcpbiCols pcpbiColright">
                <ColumnRight
                  continueCTA={"/orderreview"}
                  handleRightColumnMobileToggle={this.props.handleRightColumnMobileToggle}
                  appState={this.props.appState}
                  handleInCartFnbItemQuantity={this.props.handleInCartFnbItemQuantity}
                  // handleFindMyBookingSubmit={this.props.handleFindMyBookingSubmit}
                  populateItemModifierItems={this.props.populateItemModifierItems}
                  // populateItemSmartModifierItems={this.props.populateItemSmartModifierItems}
                  calculateItemRowTotal={this.props.calculateItemRowTotal}
                  calculateCartSubtotal={this.props.calculateCartSubtotal}
                  calculateCartTax={this.props.calculateCartTax}
                  calculateCartGrandTotal={this.props.calculateCartGrandTotal}
                  deleteItemFromCart={this.props.deleteItemFromCart}
                  disableItemDelete={false}
                  cartDrawerToggle={this.props.cartDrawerToggle}
                  // calculateRedemeedGiftcardTotal={this.props.calculateRedemeedGiftcardTotal}
                  // menuPageOpenPaymentDrawer={this.menuPageOpenPaymentDrawer}
                  populateCookieData={this.props.populateCookieData}
                />
              </aside>
            </section>

            <section className="pcpbBottomstrap">
              <section className="pcpbbsInner">
                <aside className="pcpbsTrigger" onClick={() => this.props.cartDrawerToggle()}>
                  <FontAwesomeIcon className="cartIcon" icon={faCartShopping}></FontAwesomeIcon>
                  <h2>
                    <span>View Cart</span>
                    <strong>
                      {`${this.props.appState.cartData.length > 0 ? this.props.calculateCartGrandTotal(this.props.appState.cartData) : "$0.00"}`}{" "}
                      <FontAwesomeIcon icon={faAngleUp} className="footerAngleUp"></FontAwesomeIcon>
                    </strong>
                  </h2>
                </aside>
                <aside className="btnswrap">
                  {/* <NavLink to="/orderreview" className={`${this.props.appState.cartData.length > 0 ? "btn btndefault" : "btn btndefault disabled"}`} title="Checkout">
                            Checkout
                          </NavLink> */}
                  <button
                    type="button"
                    // className={`${this.props.appState.cartData.length > 0 ? "btn btndefault" : "btn btndefault disabled"}`}
                    className={`${this.props.appState.cartData.length > 0 ? "btn btntext" : "btn btntext disabled"}`}
                    onClick={() => this.props.populateCookieData(true)}
                    title="Place Order"
                  >
                    Place Order
                  </button>
                  {/* {this.props.appState.bookingForSeat == "10001" ? (
                    <button
                      type="button"
                      className={`${this.props.appState.cartData.length > 0 ? "btn btndefault" : "btn btndefault disabled"}`}
                      // onClick={() => this.setState({paymentDrawerShow: true})}
                      onClick={() => this.props.handleRightColumnMobileToggle()}
                      title="Review Order"
                    >
                      Review Order
                    </button>
                  ) : (
                    <button
                      type="button"
                      className={`${this.props.appState.cartData.length > 0 ? "btn btndefault" : "btn btndefault disabled"}`}
                      // onClick={() => this.setState({paymentDrawerShow: true})}
                      onClick={() => this.menuPageOpenPaymentDrawer()}
                      title="Place Order"
                    >
                      Place Order
                    </button>
                  )} */}
                </aside>
              </section>
            </section>
          </section>
        </section>
      </section>
    );
  }
}

export default Menu;
